import { getAccHostname } from '@adsk/acs-sc-web-platform-api';

export const getProjectUrl = (projectId: string): string => {
  const projectUrl = `${getAccHostname()}/build/rfis/projects/${projectId}`;
  return projectUrl;
};
